import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import historicsFields from '../../../fields/historicsFields';

export const columnsSimCardsHistoricsId = 'simCardsHistorics';

export const columnsSimCardsHistorics = (headerPackage) => {
    return ([
        // ColumnSelection
        generateColumnDefByField({
            field: historicsFields.SIM_CARDS_HISTORICS.SIM_ICCID,
            headerPackage: headerPackage
        })
    ]).filter(col => !!col);
};